import Layout from "../../layouts/layout"
import MainPageLayout from "../../components/main-page-layout/mainPageLayout"


import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { toast } from "react-toastify"

import Loading from "../../components/loading/loading"

import { ReactComponent as Edit } from "../../assets/icons/generals/Edit.svg"
import { ReactComponent as Delete } from "../../assets/icons/generals/Delete.svg"
import { ReactComponent as Filter } from "../../assets/icons/shapes/filter.svg"
import { useRequestProcessor } from "../../api/requestProcessor"
import { deleteSingleNotification, getAllNotifications } from "../../api/notifications"
import { confirmAlert } from "react-confirm-alert"
import Pagination from "../../components/pagination/pagination"





const Notifications = () => {

    const navigate = useNavigate();

    const [activeTab, setActiveTab] = useState(0)
    const [searchKeyword, setSearchKeyword] = useState("")
    const [page, setPage] = useState(1)

    async function onDeleteHandler(data, type) {
        confirmAlert({
            overlayClassName: "modalBackDrop-bg",
            customUI: ({ onClose }) => {
                return (
                    <div className='bg-white wsm:w-full w-[750px] py-8 px-4 rounded-xl font-bold'>
                        <h1 className=" text-center pb-4">
                            {"آیا از حذف " + type + " " + data.title + " مطمعن هستید؟"}
                        </h1>
                        <div className="flex justify-around ">

                            <button className="" onClick={onClose}>خیر</button>
                            <button className="border-2 text-red-500 rounded-lg py-3 !px-5 border-red-500"
                                onClick={() => { deleteMutate(data.id); onClose() }}>
                                بله
                            </button>
                        </div>
                    </div>
                );
            }
        })
    }


    const { Query, Mutate } = useRequestProcessor()

    const { data, isLoading, refetch } = Query(
        ['getAllNotifications', searchKeyword, page],
        () => getAllNotifications(searchKeyword, page),
        { enabled: Boolean(searchKeyword) || searchKeyword == "" }
    );
    const { mutate: deleteMutate } = Mutate(
        "deleteBlog",
        deleteSingleNotification,
        {
            onSuccess: (data) => {
                toast.success(data.message)//This is the response you get back
                refetch()
            }
            ,
            onError: (data) => {
                toast.error(data.response.data.message)
            }
        }
    )


    const handlePageClick = (event) => {
        setPage(event.selected + 1);
    };

    return (
        <Layout>
            <MainPageLayout buttonTitle={"ایجاد اعلامیه جدید"} buttonLink={"/admin/notifications/create"} title={"اعلامیه ها"} >
                <div className="flex justify-between py-3 items-center  wsm:flex-col-reverse border-b">
                    <div className="flex [&>*]:px-4 [&>*]:py-1 p-2 bg-[#eef3f7] rounded-lg text-[#5e6278]">
                        <button onClick={() => setActiveTab(0)} className={activeTab === 0 ? "bg-white rounded-lg text-black" : ""}>همه</button>
                        <button onClick={() => setActiveTab(1)} className={activeTab === 1 ? "bg-white rounded-lg text-black" : ""}>خوانده نشده</button>
                    </div>
                    {/* <div className="flex wsm:mb-4">

                        <input type="text" className='form-input !w-full' value={searchKeyword}
                            onChange={(e) => setSearchKeyword(e.target.value)}
                            placeholder='جستوجو اعلامیه ها ...' />

                        <span className="flex text-sky-500 font-serif items-center mr-3 cursor-pointer">
                            <Filter width={24} height={24} />
                            فیلتر
                        </span>
                    </div> */}
                </div>
                <div className="flex flex-col my-4">
                    {
                        data?.data?.length ?

                            data?.data?.map(el => (
                                <div key={el.id} className={`text-[#575757] border-b-2 flex items-center justify-between border-[#d5d5d5] hover:bg-[#fafafa] p-3 last:border-b-0
                            px-2 ${el.read_at ? " cursor-pointer" : "border-r-4 border-r-bs-yellow bg-[#f5f5f5]"} `}  >

                                    <p className=" flex items-center py-2" >
                                        {el.title}
                                        <span className="text-center text-xs pr-2 text-gray-400">
                                            {
                                                new Date(el.send_at*1000).toLocaleString('fa-IR')
                                            }
                                        </span>
                                    </p>
                                    <div className="flex">
                                        {/* <button className="flex items-center text-bs-yellow font-bold bg-bs-green px-6 py-3 rounded-full" >
                                            مشاهده
                                        </button> */}
                                        <div className="flex justify-evenly items-center mx-3">
                                            <div className="cursor-pointer ml-4" onClick={() => navigate('/admin/notifications/edit/' + el.id)}><Edit width={"20"} height="20" /></div>
                                            <div className=" cursor-pointer" onClick={() => { onDeleteHandler(el, "اعلامیه") }} ><Delete width={"20"} height="20" /></div>
                                        </div>
                                    </div>


                                </div>
                            )
                            )
                            :
                            <div>
                                <p>هیچ اطلاعیه ای پیدا نشد</p>
                            </div>
                    }
                </div>
                {
                    isLoading && <Loading />
                }
                {data?.meta?.last_page > 1 && <Pagination handlePageClick={handlePageClick} lastPage={data?.meta?.last_page} />}

            </MainPageLayout>
        </Layout>
    )
}

export default Notifications